import { useMemo } from "react"

import { useArticleNumberSearchResultsQuery } from "shared/api/price/queries.generated"

import { useProductObj } from "entities/products/model/useProductObj"

import { transformProductObjToProductSearchResult } from "../lib/transformProductObjToProductSearchResult"
import { ProductSearchResult } from "../types/GlobalSearch"

interface UseArticleNumberSearchProps {
  searchTerm?: string | null
}

function isArticleNumber(s: string | null | undefined) {
  if (!s) return false
  return /^8\d{6}$/.test(s)
}

export function useArticleNumberSearch({
  searchTerm
}: UseArticleNumberSearchProps) {
  const {
    data,
    loading: isLoading,
    error
  } = useArticleNumberSearchResultsQuery({
    variables: { mnr: searchTerm ?? "" },
    skip: !isArticleNumber(searchTerm)
  })

  const { productObj, productBaseVariantObj } = useProductObj(
    data?.articleNumberSearchResults?.variantKey ?? "",
    {
      returnHiddenProducts: false
    }
  )
  const product = productBaseVariantObj || productObj

  const results = useMemo<ProductSearchResult[]>(() => {
    return product && searchTerm
      ? [
          {
            ...transformProductObjToProductSearchResult(product),
            articleNumber: data?.articleNumberSearchResults?.id,
            variantKey:
              data?.articleNumberSearchResults?.variantKey || undefined,
            matchInfo: {
              articleNumber: {
                value: data?.articleNumberSearchResults?.id,
                searchTerm: data?.articleNumberSearchResults?.id
              }
            }
          }
        ]
      : []
  }, [product?.id(), searchTerm])

  return {
    results,
    isLoading,
    error
  }
}
